import { api_create_message_path } from '../../routes';
import request from './request';

export async function createMessage(
  userId: number,
  message: string
): Promise<Record<string, never>> {
  const res = await request('post', api_create_message_path(), { user_id: userId, message });
  return res;
}
